<template>
  <nav class="navbar">
      <v-toolbar fixed dark flat height="60" color="red darken-4">
        <v-toolbar-title  class="title font-weight-regular">Hematology Outlines Flashcards
          <div class="caption">
            H.H. Rashidi, B.D. Fennell, J.C. Nguyen
          </div>
        </v-toolbar-title>
      </v-toolbar>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      user: null,
    }
  },
}
</script>

<style>
</style>
